import { isStringDigitsOnly } from 'CorePackage/MainModule/validators/isStringDigitsOnly';

import { PLAN_ID_LENGTH } from '../constants/planIdLength';

export const makePlanIdStringValidator = (errorMsg: string) => (value: string) => {
  if (value) {
    if (value.length !== PLAN_ID_LENGTH || !isStringDigitsOnly(value)) {
      return errorMsg;
    }
  }

  return undefined;
};
